<template>
  <!--begin::Modal - Create App-->
  <div
    class="modal fade"
    id="kt_modal_create_picture"
    ref="createAppModalRef"
    tabindex="-1"
    aria-hidden="true"
  >
    <!--begin::Modal dialog-->
    <div class="modal-dialog modal-dialog-centered modal-xl">
      <!--begin::Modal content-->
      <div class="modal-content">
        <!--begin::Modal header-->
        <div class="modal-header">
          <!--begin::Modal title-->
          <h2 class="c-umt1st">Hướng dẫn upload hình thẻ</h2>
          <!--end::Modal title-->

          <!--begin::Close-->
          <div
            class="btn btn-sm btn-icon btn-active-color-primary"
            data-bs-dismiss="modal"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg src="/media/icons/duotune/arrows/arr061.svg" />
            </span>
          </div>
          <!--end::Close-->
        </div>
        <!--end::Modal header-->

        <!--begin::Modal body-->
        <div class="modal-body py-lg-2 px-lg-5">
          <!--begin::Stepper-->
          <div
            class="p-4 stepper stepper-pills stepper-column d-flex flex-column flex-xl-row flex-row-fluid"
            id="kt_modal_create_app_stepper"
            ref="createAppRef"
          >
            <!--begin::Content-->
            <div class="w-100">
               
                <h5>Những yêu cầu đối với hình thẻ như sau: </h5>
                <div class="ps-3">
                    - Hình màu <br />

- Kích thước tỷ lệ 4x6, phải có chất lượng tốt (lớn hơn 300dpi), độ phân giải cao <br />

- Chụp trong vòng 6 tháng gần đây <br />

- Chụp trên nền trắng hoặc xanh dương. Khuyến khích sử dụng chụp trên nền trắng <br />

- Yêu cầu về khuôn mặt: <br />
<div class="ps-5 py-3">
    • Khuôn mặt trong hình phải chiếm từ 70-80% khung hình <br />

    • Mặt hướng thẳng về phía máy hình, không biểu cảm, mở mắt, không cười, không hở miệng (trừ các trường hợp đặc biệt, khuyết tật) <br />
</div>


- Yêu cầu về trang phục: <br />
<div class="ps-5 py-3">
    • Trang phục lịch sự <br />
    • Không mặc quân phục, trang phục của các lực lượng chấp pháp nhà nước hoặc của các tổ chức chính trị xã hội, ngoại trừ trang phục tu hành dùng mặc thường ngày (nếu có). <br />
    • Màu trang phục không trùng màu nền, hoặc phải có sự phân biệt với màu nền. <br />
    • Không đội mũ, áo trùm đầu. Ngoại trừ theo quy định đồ mặc thường ngày của tôn giáo, tuy nhiên phải đảm bảo thấy rõ toàn bộ khuôn mặt và không có bóng mờ che khuôn mặt. <br />
</div>







- Không có logo, phù hiệu hoặc các câu chữ, hình thù khác. <br />

- Không đeo các phụ kiện, như tai nghe, … ngoại trừ máy trợ thính theo yêu cầu của y tế. <br />

- Không đeo kính, ngoại trừ trường hợp bất đắc dĩ theo yêu cầu của y tế, nhưng phải nhìn rõ mắt của người trong hình. 
                </div>
            </div>
            <!--end::Content-->
          </div>
          <!--end::Stepper-->
        </div>
        <!--end::Modal body-->
      </div>
      <!--end::Modal content-->
    </div>
    <!--end::Modal dialog-->
  </div>
  <!--end::Modal - Create App-->
</template>

<style lang="scss" scoped>
.el-input--suffix .el-input__inner {
  background-color: #f5f8fa;
}

.el-input__inner {
  background-color: #f5f8fa;
}
.table-bordered td, .table-bordered th {
    border: 1px solid #dee2e6;
}
.table-bordered thead td, .table-bordered thead th {
    border-bottom-width: 2px;
}
.table-bordered td,.table-bordered th {
  vertical-align: middle;
}
</style>